import { getStringErrors, getValidationErrorDictionary, getValidationErrors } from "../../../../logic/ValidationChecks/Validation";
import { Shift } from "../../../../stores/models/Shift";
import { ValidationCheck } from "../../../../stores/models/ValidationCheck";
import { ValidationError } from "../../../../stores/models/ValidationError";
import { IAdminVolunteerRegistrationFlowValues } from "../_interfaces/IAdminVolunteerRegistrationFlowValues";
import { VolunteerRegistrationFlowExternalState } from "../_interfaces/IAdminVolunteerRegistrationStepTypeValues";

type StepContext = IAdminVolunteerRegistrationFlowValues & VolunteerRegistrationFlowExternalState;

const validationChecks: (context: StepContext) => ValidationCheck<StepContext>[] =
    (context) => [{
        name: 'Volunteer(s) selected',
        condition: (context: StepContext) => {
            return context.volunteerIds.length > 0;
        },
        error: new ValidationError('You must select at least one volunteer.', ['volunteerIds'])
    }, {
        name: 'Enough slots remaining',
        condition: (context: StepContext) => {
            const isShiftSeries = context.offsets.length !== 0;
            const topLevelShift = new Shift(context.topLevelShift);
            return isShiftSeries || (topLevelShift.unlimitedSlots || context.volunteerIds.length <= topLevelShift.slotsLeft);
        },
        error: new ValidationError('There are not enough remaining slots.', ['volunteerIds'])
    }];

export const AdminVolunteerRegistrationValidation = (context: StepContext) => {
    return {
        errors: getStringErrors(getValidationErrorDictionary(validationChecks, context)),
        valid: getValidationErrors(validationChecks, context).length === 0
    }
}